module.exports = __webpack_public_path__ + "img/autocolante-o.6634d8af.svg";